<ng-container *ngFor="let fly of flightsInternal; let i = index">
  <accordion class="accordionModalProduct">
    <accordion-group
      class="mb-1 mx-auto accordionGroupModalProduct"
      [(isOpen)]="isAccordionOpen[i]"
      (isOpenChange)="onAccordionToggle(i, $event)"
    >
      <!-- Custom heading: ngx-bootstrap renders everything inside [accordion-heading] as the header content. -->
      <div accordion-heading class="accordion-heading-wrapper">
        <span class="accordion-heading-text text-truncate" [title]="getHeading(i)">
          {{ getHeading(i) }}
        </span>
      </div>
      <div class="d-flex" style="width: 98%">
        <div class="d-flex align-items-center justify-content-between w-100" style="gap: 10px; padding-left: 10px;">
          <!-- Flight Internal Toggle - In / Out -->
          <div class="d-flex align-items-center" style="gap: 0.5em; margin-left: 0.5em;">
            <span
              class="font-Rubik"
              [ngStyle]="{
                'font-size': '13px',
                'font-weight': getFormForFly(i)?.get('flightDirection')?.value === 'DEPARTURE' ? 600 : 400,
                'color': getFormForFly(i)?.get('flightDirection')?.value === 'DEPARTURE' ? '#000000' : '#9aa0a6'
              }"
            >Salida</span>

            <label
              class="switch mb-0"
              style="position: relative; display: inline-block; width: 44px; height: 22px;"
            >
              <input
                type="checkbox"
                [checked]="getFormForFly(i)?.get('flightDirection')?.value === 'ARRIVAL'"
                (change)="onFlightDirectionToggle(i, $event)"
                [disabled]="component === 'fly'"
                style="opacity: 0; width: 0; height: 0;"
              />
              <span
                class="slider round"
                [ngStyle]="{
                  'position': 'absolute',
                  'cursor': component === 'fly' ? 'not-allowed' : 'pointer',
                  'top': '0',
                  'left': '0',
                  'right': '0',
                  'bottom': '0',
                  'background-color': getFormForFly(i)?.get('flightDirection')?.value === 'ARRIVAL'
                    ? (getClientsSettingAppBooking?.clients_setting_global?.color_main_1 || '#34c26d')
                    : '#cccccc',
                  'transition': '.3s',
                  'border-radius': '22px'
                }"
              ></span>
              <span
                class="slider-knob"
                [ngStyle]="{
                  'position': 'absolute',
                  'height': '18px',
                  'width': '18px',
                  'left': getFormForFly(i)?.get('flightDirection')?.value === 'ARRIVAL' ? '22px' : '4px',
                  'bottom': '2px',
                  'background-color': 'white',
                  'transition': '.3s',
                  'border-radius': '50%'
                }"
              ></span>
            </label>

            <span
              class="font-Rubik"
              [ngStyle]="{
                'font-size': '13px',
                'font-weight': getFormForFly(i)?.get('flightDirection')?.value === 'ARRIVAL' ? 600 : 400,
                'color': getFormForFly(i)?.get('flightDirection')?.value === 'ARRIVAL' ? '#000000' : '#9aa0a6'
              }"
            >Llegada</span>
          </div>

          <!-- Delete Flight Internal Button -->
          <img
            *ngIf="i === flightsInternal.length - 1"
            width="18px"
            height="20px"
            style="cursor: pointer"
            tooltip="Eliminar vuelo interno"
            placement="bottom"
            (click)="deleteFlyInternal(i)"
            src="../../../../assets/icons/itinerary/delet.svg"
            alt=""
          />
        </div>
      </div>
      <div [formGroup]="getFormForFly(i)">
        <div class="d-flex text-left pt-0 pl-4 pr-3 fontysizer-15 pt-4 pb-1">
          <div class="d-flex" style="gap: 0.5em">
            <div
              class="d-flex justify-content-center align-items-center"
              style="width: 36px; height: 36px; border-radius: 50%; background-color: #e3e3e3"
            >
              <i class="bi-edit icon bi-airplane" aria-hidden="true"></i>
            </div>

          </div>

          <div class="form-group w-100 m-0 ml-2 mb-4 pt-0 pb-0 text-left d-flex flex-row justify-content-between scroll">
            <div class="position-relative w-100" *ngIf="!selectedAirportNameOut[i]">
              <div class="w-100">
                <input
                  (valueChanged)="_myCallbackAirportOut($event, i)"
                  ngui-auto-complete
                  formControlName="airportOut"
                  type="text"
                  name="airportOut"
                  class="form-control font-Rubik font-inputs"
                  value-formatter="name"
                  placeholder="Aeropuerto"
                  [source]="getAutoCompleteSource('airport')"
                  display-property-name="name"
                  [list-formatter]="_myListFormatterAirport"
                  accept-user-input="false"
                  autocomplete="off"
                />
              </div>
              <div
                *ngIf="!selectedAirportNameOut[i] && getFormForFly(i)?.get('airportOut')?.touched"
                class="position-absolute text-danger ml-2"
                style="font-size: 12px; font-weight: 600; bottom: -20px"
              >
                Ingrese un aeropuerto y seleccione una opción
              </div>
            </div>
            <div *ngIf="selectedAirportNameOut[i]" class="position-relative w-100">
              <span class="container-input-icon-cancel w-100">
                <input
                  [value]="selectedAirportNameOut[i]"
                  type="text"
                  [ngStyle]="{ 'pointer-events': component === 'fly' ? 'none' : 'auto' }"
                  name="airportOut"
                  class="form-control font-Rubik font-inputs"
                  readonly
                />
                <span class="square-class-secondArrival" *ngIf="component !== 'fly'">
                  <div class="container-square-secondArrival">
                    <i
                      class="bi bi-x x-icon-cancel"
                      (mouseenter)="isHoveredCancelDate = true"
                      (mouseleave)="isHoveredCancelDate = false"
                      tooltip="Eliminar Aeropuerto de llegada"
                      placement="bottom"
                      (click)="deleteSelectedOption('airportOut', i)"
                    ></i>
                  </div>
                </span>
              </span>
            </div>
          </div>
        </div>

        <div class="form-group m-0 mb-4 pt-0 pb-0 text-left col-12 d-flex flex-row justify-content-between scroll" style="gap: 0.5em">
          <div class="d-flex" style="width: 100%; gap: 3px">
            <div class="w-100 position-relative" *ngIf="!selectedAirlineOutName[i]">
              <input
                (valueChanged)="_myCallbackAirlineOut($event, fly, i)"
                ngui-auto-complete
                formControlName="airlineOut"
                type="text"
                id="airlineOut"
                name="Airline"
                class="form-control font-Rubik font-inputs"
                style="width: 100% !important"
                value-formatter="name"
                placeholder="Aerolínea"
                [source]="getAutoCompleteSource('airline')"
                display-property-name="name"
                [list-formatter]="_myListFormatterAirline"
                accept-user-input="false"
                autocomplete="off"
              />
              <div
                *ngIf="!selectedAirlineOut[i] && getFormForFly(i)?.get('airlineOut')?.touched"
                class="position-absolute text-danger ml-2"
                style="font-size: 12px; font-weight: 600; bottom: -20px"
              >
                Ingrese una aerolínea y seleccione una opción
              </div>
            </div>

            <div *ngIf="selectedAirlineOutName[i]" class="position-relative w-100">
              <span class="container-input-icon-cancel w-100">
                <input
                  [value]="selectedAirlineOutName[i]"
                  type="text"
                  [ngStyle]="{ 'pointer-events': component === 'fly' ? 'none' : 'auto' }"
                  id="airlineOut"
                  name="Airline"
                  class="form-control font-Rubik font-inputs"
                  readonly
                />
                <span class="square-class-secondArrival" *ngIf="component !== 'fly'">
                  <div class="container-square-secondArrival">
                    <i
                      class="bi bi-x x-icon-cancel"
                      (mouseenter)="isHoveredCancelDate = true"
                      (mouseleave)="isHoveredCancelDate = false"
                      tooltip="Eliminar Aerolínea de llegada"
                      placement="bottom"
                      (click)="deleteSelectedOption('airlineOut', i)"
                    ></i>
                  </div>
                </span>
              </span>
            </div>

            <input
              formControlName="_flightNumberOut"
              type="text"
              class="form-control font-Rubik font-inputs btn-_numberfly"
              id="_flight-numberOut"
              style="width: 25% !important; background-color: #efefef"
              placeholder=""
              autocomplete="off"
              readonly
            />
          </div>
          <div class="position-relative" style="width: 40%">
            <input
              *ngIf="component !== 'fly'"
              formControlName="flightNumberOut"
              [ngStyle]="{ 'pointer-events': component === 'fly' ? 'none' : 'auto' }"
              style="width: 100%"
              type="text"
              class="form-control font-Rubik font-inputs btn-numberfly"
              id="flight-numberOut"
              placeholder="Número de vuelo"
              maxlength="4"
            />
            <input
              *ngIf="component === 'fly'"
              formControlName="flightNumberOut"
              style="width: 100%"
              [ngStyle]="{ 'pointer-events': component === 'fly' ? 'none' : 'auto' }"
              type="text"
              class="form-control font-Rubik font-inputs btn-numberfly"
              id="flight-numberOut"
              placeholder="Número de vuelo"
              maxlength="4"
              readonly
            />

            <div
              *ngIf="getFormForFly(i)?.get('flightNumberOut')?.touched && getFormForFly(i)?.get('flightNumberOut')?.invalid"
              class="position-absolute text-danger ml-2"
              style="font-size: 12px; font-weight: 600; bottom: -20px"
            >
              Ingrese número de vuelo
            </div>
          </div>
        </div>

        <div
          class="form-group m-0 mb-4 pt-0 pb-0 text-left col-12 d-flex flex-row align-items-center justify-content-center"
          style="gap: 0.5em"
        >
          <div class="form-group m-0 pt-0 pb-0 text-left d-flex flex-row align-items-center" style="gap: 3px; width: 50%">
            <input
              formControlName="departureDateOut"
              type="text"
              class="form-control font-Rubik font-inputs px-3"
              placeholder="Fecha de Salida"
              autocomplete="off"
              bsDatepicker
              [minDate]="minDateValidDeparture(i)"
              [placement]="'top'"
              [bsConfig]="dpConfig"
            />

            <!-- NEW WHEEL TIME PICKER -->
            <div class="wheel-picker-wrapper" style="width: 39%; position: relative" [formGroup]="getFormForFly(i)">
              <input
                type="text"
                class="form-control font-Rubik font-inputs"
                [value]="getFormForFly(i)?.get('departureHourOut')?.value"
                [ngStyle]="{ 'pointer-events': (component === 'fly' || !getFormForFly(i)?.get('departureDateOut')?.value) ? 'none' : 'auto', 'background-color': !getFormForFly(i)?.get('departureDateOut')?.value ? '#efefef' : '#FFFFFF', 'color': !getFormForFly(i)?.get('departureDateOut')?.value ? '#000000' : 'auto' }"
                (input)="_onManualTimeInput($event, i, 'departureHourOut')"
                (blur)="_onTimeInputBlur(i, 'departureHourOut', $event)"
                placeholder="Hora"
                inputmode="numeric"
                maxlength="5"
                pattern="^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$">
              <img src="../../../../../assets/icons/search-box/reloj-traslado.svg"
                width="20px"
                style="position: absolute;right: 1em;top:29%; cursor: pointer;"
                [ngStyle]="{ 'cursor': getFormForFly(i)?.get('departureDateOut')?.value ? 'pointer' : 'not-allowed', 'opacity': getFormForFly(i)?.get('departureDateOut')?.value ? '1' : '0.5' }"
                (click)="getFormForFly(i)?.get('departureDateOut')?.value ? toggleTimePicker(i, 'departureHourOut', $event) : null; $event.stopPropagation()"
                alt="">

              <!-- Dropdown with wheel picker -->
              <div class="wheel-picker-dropdown" *ngIf="activeTimePicker?.index === i && activeTimePicker?.field === 'departureHourOut'">
                <usb-wheel-time-picker formControlName="departureHourOut"
                  [minuteStep]="1"
                  (closed)="activeTimePicker = null">
                </usb-wheel-time-picker>
              </div>
            </div>

            <span
              class="position-absolute text-danger ml-2"
              style="font-size: 12px; font-weight: 600; bottom: -20px"
              *ngIf="getFormForFly(i)?.get('departureHourOut')?.touched && getFormForFly(i)?.get('departureHourOut')?.invalid"
              >Ingrese una hora de salida</span
            >

            <span
              class="position-absolute text-danger ml-2"
              style="font-size: 12px; font-weight: 600; bottom: -20px"
              *ngIf="getFormForFly(i)?.get('departureDateOut')?.touched && getFormForFly(i)?.get('departureDateOut')?.hasError('required')"
              >Ingrese una fecha y hora de salida</span
            >
          </div>
          <!-- <timepicker [ngClass]="{'is-valid':_formFlights.value.departureHourOut != null, 'is-invalid': _formFlights.value.departureHourOut == null}"  formControlName="departureHourOut" [showMeridian]="!ismeridian"></timepicker> -->
          <div class="form-group m-0 pt-0 pb-0 text-left d-flex flex-row align-items-center" style="gap: 3px; width: 50%">
            <input
              formControlName="arrivalDateOut"
              type="text"
              class="form-control font-Rubik font-inputs px-3"
              id="arrivalDateOut"
              placeholder="Fecha de Llegada"
              [ngStyle]="{ 'pointer-events': component === 'fly' ? 'none' : 'auto' }"
              autocomplete="off"
              bsDatepicker
              [minDate]="getFormForFly(i).get('departureDateOut').value"
              [placement]="'top'"
              [bsConfig]="dpConfig"
              readonly
            />
            <!-- ORIGINAL TIME INPUT -->
            <!-- <input
              class="form-control font-Rubik font-inputs"
              style="width: 39%"
              formControlName="arrivalHourOut"
              [ngStyle]="{ 'pointer-events': component === 'fly' ? 'none' : 'auto' }"
              type="time"
            /> -->
            <!-- NEW WHEEL TIME PICKER -->
            <div class="wheel-picker-wrapper" style="width: 39%" [formGroup]="getFormForFly(i)">
              <input
                type="text"
                class="form-control font-Rubik font-inputs"
                [value]="getFormForFly(i)?.get('arrivalHourOut')?.value"
                [ngStyle]="{ 'pointer-events': (component === 'fly' || !getFormForFly(i)?.get('arrivalDateOut')?.value) ? 'none' : 'auto', 'background-color': !getFormForFly(i)?.get('arrivalDateOut')?.value ? '#efefef' : '#FFFFFF', 'color': !getFormForFly(i)?.get('arrivalDateOut')?.value ? '#000000' : 'auto' }"
                (input)="_onManualTimeInput($event, i, 'arrivalHourOut')"
                (blur)="_onTimeInputBlur(i, 'arrivalHourOut', $event)"
                placeholder="Hora"
                inputmode="numeric"
                maxlength="5"
                pattern="^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$">
              <img src="../../../../../assets/icons/search-box/reloj-traslado.svg"
                width="20px"
                style="position: absolute;right: 1em;top:29%; cursor: pointer;"
                [ngStyle]="{ 'cursor': getFormForFly(i)?.get('arrivalDateOut')?.value ? 'pointer' : 'not-allowed', 'opacity': getFormForFly(i)?.get('arrivalDateOut')?.value ? '1' : '0.5' }"
                (click)="getFormForFly(i)?.get('arrivalDateOut')?.value ? toggleTimePicker(i, 'arrivalHourOut', $event) : null; $event.stopPropagation()"
                alt="">

              <!-- Dropdown with wheel picker -->
              <div class="wheel-picker-dropdown" *ngIf="activeTimePicker?.index === i && activeTimePicker?.field === 'arrivalHourOut'">
                <usb-wheel-time-picker formControlName="arrivalHourOut"
                  [minuteStep]="1"
                  (closed)="activeTimePicker = null">
                </usb-wheel-time-picker>
              </div>
            </div>

            <span
              class="position-absolute text-danger ml-2"
              style="font-size: 12px; font-weight: 600; bottom: -20px"
              *ngIf="getFormForFly(i)?.get('arrivalHourOut')?.touched && getFormForFly(i)?.get('arrivalHourOut')?.invalid"
              >Ingrese una hora de llegada</span
            >
            <span
              class="position-absolute text-danger ml-2"
              style="font-size: 12px; font-weight: 600; bottom: -20px"
              *ngIf="getFormForFly(i)?.get('arrivalDateOut')?.touched && getFormForFly(i)?.get('arrivalDateOut')?.invalid"
              >Ingrese una fecha y hora de llegada</span
            >
          </div>
        </div>

        <div class="form-group m-0 mb-4 pt-0 pb-0 text-left col-12 d-flex flex-row justify-content-between scroll" style="gap: 0.5em">
          <div class="d-flex" style="width: 100%; gap: 3px">
            <div class="w-100 position-relative" *ngIf="!selectedCityIataIn[i]">
              <input
                (valueChanged)="_myCallbackCityIataIn($event, fly, i)"
                ngui-auto-complete
                formControlName="cityDepartureIn"
                type="text"
                id="airlineIn"
                name="Airline"
                class="form-control font-Rubik font-inputs"
                style="width: 100% !important"
                value-formatter="name"
                placeholder="Escriba y seleccione el lugar de llegada"
                [source]="getAutoCompleteSourceDestination()"
                display-property-name="name"
                [list-formatter]="_myListFormatterDestination"
                accept-user-input="false"
                autocomplete="off"
              />
              <div
*ngIf="!selectedCityIataIn[i] && getFormForFly(i)?.get('cityDepartureIn')?.touched"
                class="position-absolute text-danger ml-2"
                style="font-size: 12px; font-weight: 600; bottom: -20px"
              >
                Ingrese un lugar de llegada y seleccione una opción
              </div>
            </div>
            <div *ngIf="selectedCityIataIn[i]" class="position-relative w-100">
              <span class="container-input-icon-cancel w-100">
                <input
                  [value]="selectedCityIataInName[i]"
                  [ngStyle]="{ 'pointer-events': component === 'fly' ? 'none' : 'auto' }"
                  type="text"
                  id="selectedCityIataIn"
                  name="selectedCityIataIn"
                  class="form-control font-Rubik font-inputs"
                  readonly
                />
                <span class="square-class-secondArrival" *ngIf="component !== 'fly'">
                  <div class="container-square-secondArrival">
                    <i
                      class="bi bi-x x-icon-cancel"
                      (mouseenter)="isHoveredCancelDate = true"
                      (mouseleave)="isHoveredCancelDate = false"
                      tooltip="Eliminar lugar de salida"
                      placement="bottom"
                      (click)="deleteSelectedOption('cityDepartureIn', i)"
                    ></i>
                  </div>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end" style="width: 98%">
        <button
          *ngIf="isAccordionOpen[i]"
          type="button"
          (click)="_flightsApply(i)"
          class="btn-sm font-Rubik btn-buscar semi-black mr-1"
          style="border: none"
          [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
        >
          Aceptar
        </button>
      </div>
    </accordion-group>
  </accordion>
</ng-container>
